"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ChartTypeField;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _classnames = _interopRequireDefault(require("classnames"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ChartTypeField(_ref) {
  var chartTypes = _ref.chartTypes;
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "chartType"
  }, function (_ref2) {
    var field = _ref2.field,
      form = _ref2.form;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].chartTypeWrapper
    }, chartTypes.map(function (chart) {
      var Icon = chart.icon;
      return /*#__PURE__*/_react["default"].createElement("button", {
        key: chart.name,
        type: "button",
        onClick: function onClick() {
          return form.setFieldValue(field.name, chart.name);
        },
        className: (0, _classnames["default"])('btn btn-lg', field.value === chart.name ? "btn-secondary ".concat(_style["default"].selected) : 'btn-primary', _style["default"].chartTypeBtn)
      }, /*#__PURE__*/_react["default"].createElement(Icon, null), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].label
      }, chart.label));
    }));
  });
}